import Icons from '../../components/icons/Icons'
import './RootPage.css'

const RootPage = () => {
    return (
        <Icons />
    )
}

export default RootPage